<template>
  <div class>
    <div class="history">
      <div class="card">
        <span class="icon">
          <img src="@/assets/svg/about/us_timeline_icon.svg" alt />
        </span>
        <div class="card-content">
          <h2 class="title">2008年</h2>
          <div class="box">
            <p>2月：创始人杨牧仁开始了完全生死未卜的翡翠之路。</p>
            <img src="https://res.jaadee.net/active/course/course_1.jpg" alt />
            <p>3月：创建了翡翠王朝品牌和互联网站点，是全国最早创立的翡翠类互联网垂直类品牌。</p>
            <img src="https://res.jaadee.net/active/course/course_2.jpg" alt />
            <!-- <p>5月：翡翠王朝立下企业经营方略：专供超值好翡翠！明码标价，一口价销售，打破“黄金有价玉无价”的传统;</p>
            <img src="@/assets/images/about/us_history_3.png" alt /> -->
            <p>8月：行业内首家提出7天自由退换保障。</p>
            <img src="https://res.jaadee.net/active/course/course_3.jpg" alt />
          </div>
        </div>
      </div>
      <div class="card">
        <span class="icon">
          <img src="@/assets/svg/about/us_timeline_icon.svg" alt />
        </span>
        <div class="card-content">
          <h2 class="title">2009年</h2>
          <div class="box">
            <p>6月：创始人杨牧仁因互联网发展需求重新在昆明建立了团队。</p>
            <img src="https://res.jaadee.net/active/course/course_4.jpg" alt />
          </div>
        </div>
      </div>
      <div class="card">
        <span class="icon">
          <img src="@/assets/svg/about/us_timeline_icon.svg" alt />
        </span>
        <div class="card-content">
          <h2 class="title">2010年</h2>
          <div class="box">
            <p>1月：初定根基我们再次回到瑞丽，在翡翠源头扎根发展。</p>
            <img src="https://res.jaadee.net/active/course/course_5.jpg" alt />
            <!-- <p>12月：翡翠王朝在新浪发送了第一条微博。</p>
            <img src="@/assets/images/about/us_history_7.png" alt /> -->
          </div>
        </div>
      </div>
      <div class="card">
        <span class="icon">
          <img src="@/assets/svg/about/us_timeline_icon.svg" alt />
        </span>
        <div class="card-content">
          <h2 class="title">2011年</h2>
          <div class="box">
            <!-- <p>2月：成交了第一笔来自美国的订单；</p>
            <img src="@/assets/images/about/us_history_8.png" alt /> -->
            <p>3月：我们成交了创办以来首笔单件过千万的订单。</p>
            <img src="https://res.jaadee.net/active/course/course_6.jpg" alt />
          </div>
        </div>
      </div>
      <div class="card">
        <span class="icon">
          <img src="@/assets/svg/about/us_timeline_icon.svg" alt />
        </span>
        <div class="card-content">
          <h2 class="title">2012年</h2>
          <div class="box">
            <p>3月：翡翠王朝网站总访问数突破3500万。</p>
            <img src="https://res.jaadee.net/active/course/course_7.jpg" alt />
            <p>
              4月：本着对用户负责的专业态度，开始招募和培养翡翠专家，严选货品 。
              <!-- <br />12月：百分之一爱心俱乐部成立。 -->
            </p>
            <img src="https://res.jaadee.net/active/course/course_8.jpg" alt />
            <p>
              12月：百分之一爱心俱乐部成立，立志要做一家有社会责任感的企业。
            </p>
            <img src="https://res.jaadee.net/active/course/course_9.jpg" alt />
          </div>
        </div>
      </div>
      <div class="card">
        <span class="icon">
          <img src="@/assets/svg/about/us_timeline_icon.svg" alt />
        </span>
        <div class="card-content">
          <h2 class="title">2013年</h2>
          <div class="box">
            <p>
              7月：翡翠王朝获荣誉称号。
            </p>
            <img src="https://res.jaadee.net/active/course/course_10.jpg" alt />
            <p>10月：中共瑞丽市委宣传部与翡翠王朝共同创办“瑞丽工”玉雕文化项目。</p>
            <img src="https://res.jaadee.net/active/course/course_11.jpg" alt />
            <!-- <p>11月：翡翠王朝昆明公司正式成立，正式提出产品、团队、品牌铁三角齐头并进的发展模式；</p>
            <img src="@/assets/images/about/us_history_11.png" alt /> -->
            <p>12月：翡翠王朝网站总访问数突破5000万。</p>
            <img src="https://res.jaadee.net/active/course/course_12.jpg" alt />
          </div>
        </div>
      </div>

      <div class="card">
        <span class="icon">
          <img src="@/assets/svg/about/us_timeline_icon.svg" alt />
        </span>
        <div class="card-content">
          <h2 class="title">2014年</h2>
          <div class="box">
            <p>1月：翡翠王朝正式启动玉雕界项目，塑造玉雕大师，传播珠宝文化。</p>
            <img src="https://res.jaadee.net/active/course/course_13.jpg" alt />
            <!-- <p>3月：建立微信公众平台翡翠王朝微刊；</p>
            <img src="@/assets/images/about/us_history_14.png" alt />
            <p>5月：翡翠王朝到佛山平洲翠宝园成立公司；</p>
            <img src="@/assets/images/about/us_history_15.png" alt /> -->
            <p>6月：翡翠王朝在广州成立办事处。</p>
            <img src="https://res.jaadee.net/active/course/course_14.jpg" alt />
            <!-- <p>
              11月：翡翠王朝全国首次举行玉雕作品慈善义拍救助罕见病患儿,我们征集了20余件作品进行爱心义卖活动，所得善款14万余元全部捐赠给云南“世纪绝症”患儿小糖果。
              <br />翡翠王朝玉雕作品慈善义拍27日开始，共同救助罕见病患儿！
              <br />
            </p>
            <img src="@/assets/images/about/us_history_16.png" alt /> -->
            <p>
              12月：创始人杨牧仁当选“云南省珠宝玉石文化产业促进会”常务副会长。
            </p>
            <img src="https://res.jaadee.net/active/course/course_15.jpg" alt />
          </div>
        </div>
      </div>
      <div class="card">
        <span class="icon">
          <img src="@/assets/svg/about/us_timeline_icon.svg" alt />
        </span>
        <div class="card-content">
          <h2 class="title">2015年</h2>
          <div class="box">
            <!-- <p>
              2月：翡翠王朝入驻并成立“翡翠王朝文化创意产业孵化基地”
              <br />
            </p>
            <img src="@/assets/images/about/us_history_17.png" alt />
            <p>3月：翡翠王朝.玉雕界名家小品馆全国巡展。</p>
            <img src="@/assets/images/about/us_history_18.png" alt />
            <p>4月：翡翠王朝与深圳奈莎NASA联姻。</p>
            <img src="@/assets/images/about/us_history_19.png" alt /> -->
            <p>
              5月：杨牧仁荣获首届德宏“励志创业 回馈社会”十大杰出企业家称号。
            </p>
            <img src="https://res.jaadee.net/active/course/course_16.jpg" alt />
            <p>6月：翡翠王朝设立“百分之一公益基金”。</p>
            <img src="https://res.jaadee.net/active/course/course_17.jpg" alt />
            <!-- <p>7月：翡翠王朝旗下轻奢珠宝品牌“珠宝乐园”启动。</p>
            <img src="@/assets/images/about/us_history_23.png" alt /> -->
            <p>9月：翡翠王朝科技创新项目获得德宏州首届创新创业大赛二等奖。</p>
            <img src="https://res.jaadee.net/active/course/course_18.jpg" alt />
            <!-- <p>10月：翡翠王朝与蓝光地产合作，开启高端珠宝私享品鉴新模式。</p>
            <img src="@/assets/images/about/us_content_11.png" alt /> -->
            <p>12月：杨牧仁应邀出席海峡两岸青年研讨会。</p>
            <img src="https://res.jaadee.net/active/course/course_45.jpg" alt />
            <p>12月：翡翠王朝荣获2015年“行业公益特别奖”。</p>
            <img src="https://res.jaadee.net/active/course/course_46.jpg" alt />
            <!-- <p>12月：翡翠王朝荣获创新型单位。</p>
            <img src="@/assets/images/about/us_history_27.png" alt /> -->
          </div>
        </div>
      </div>
      <div class="card">
        <span class="icon">
          <img src="@/assets/svg/about/us_timeline_icon.svg" alt />
        </span>
        <div class="card-content">
          <h2 class="title">2016年</h2>
          <div class="box">
            <!-- <p>
              1月：专注缅甸等东南亚国家原生态产品开发的核心项目“伊洛瓦底”在缅甸启动
              <br />
            </p>
            <img src="@/assets/images/about/us_history_28.png" alt /> -->
            <p>2月：时任云南省委副书记、省长陈豪在德宏调研时点赞翡翠王朝：“你们的创新精神很难得!”</p>
            <img src="https://res.jaadee.net/active/course/course_44.jpg" alt />
            <!-- <p>3月：翡翠王朝旗下轻奢珠宝品牌“珠宝乐园”正式上线。</p>
            <img src="@/assets/images/about/us_history_30.png" alt />
            <p>4月：以”慢得乐“红茶为核心品牌的生态养生项目”播善茶坊“启动。</p>
            <img src="@/assets/images/about/us_history_31.png" alt /> -->
            <p>12月：翡翠王朝被云南品牌行业促进会、云南民营企业家协会等多家单位联合评为“2016年度良心品牌”</p>
            <img src="https://res.jaadee.net/active/course/course_19.jpg" alt />
          </div>
        </div>
      </div>
      <div class="card">
        <span class="icon">
          <img src="@/assets/svg/about/us_timeline_icon.svg" alt />
        </span>
        <div class="card-content">
          <h2 class="title">2017年</h2>
          <div class="box">
            <p>
              5月：翡翠王朝APP上线，开始向互联网移动端时代迈进。
              <br />
            </p>
            <img src="https://res.jaadee.net/active/course/course_20.jpg" alt />
            <p>7月：2017中国·昆明国际石博览会在昆明举办，翡翠王朝作为特邀合作伙伴参展。</p>
            <img src="https://res.jaadee.net/active/course/course_21.jpg" alt />
            <p>7月：翡翠王朝APP鉴宝平台正式上线。</p>
            <img src="https://res.jaadee.net/uploads/upgrade/articleVideo/20210402/0ilqyxxyfs.jpg" alt />
            <p>
              9月：翡翠王朝成都技术研发中心成立。
              <br />
            </p>
            <img src="https://res.jaadee.net/active/course/course_22.jpg" alt />
            <p>
              10月：翡翠王朝直播平台上线，正式开启源头工厂直播销售新模式，是首家开启线上直播售卖的珠宝品牌。
              <br />
            </p>
            <img src="https://res.jaadee.net/active/course/course_23.jpg" alt />
            <p>
              11月：翡翠王朝获云南省第三届互联网大会新锐奖。
              <br />
            </p>
            <img src="https://res.jaadee.net/active/course/course_24.jpg" alt />
          </div>
        </div>
      </div>

      <div class="card">
        <span class="icon">
          <img src="@/assets/svg/about/us_timeline_icon.svg" alt />
        </span>
        <div class="card-content">
          <h2 class="title">2018年</h2>
          <div class="box">

            <p>3月：翡翠王朝纪录片《我用网络卖翡翠》荣获首届“一带一路”国际微纪录片“评委会”奖。</p>
            <img src="https://res.jaadee.net/active/course/course_25.jpg" alt />
            <p>
              5月：翡翠王朝再获“2018良心企业、匠心品牌”殊荣。
              <br />
            </p>
            <img src="https://res.jaadee.net/active/course/course_26.jpg" alt />

            <p>12月：中国改革开放40年珠宝行业表彰大会，翡翠王朝及其创始人杨牧仁荣获“先进企业”和“先锋人物”双项殊荣。</p>
            <img src="https://res.jaadee.net/active/course/course_27.jpg" alt />
          </div>
        </div>
      </div>
      <div class="card">
        <span class="icon">
          <img src="@/assets/svg/about/us_timeline_icon.svg" alt />
        </span>
        <div class="card-content">
          <h2 class="title">2019年</h2>
          <div class="box">
            <p>
              4月：翡翠王朝受邀作为“2019瑞丽国际泼水狂欢节”独家总冠名，进行现场全程实时直播。
            </p>
            <img src="https://res.jaadee.net/active/course/course_28.jpg" alt />
            <p>5月：翡翠王朝旗下品牌玉雕界首届玉雕艺术节成功举办。</p>
            <img src="https://res.jaadee.net/active/course/course_29.jpg" alt />
            <p>
              6月：“放飞希望.成就梦想”翡翠王朝助学金长期助学项目启动，签约鹿城镇中心小学，辐射周围乡村共11所小学近1500名学生。
            </p>
            <img src="https://res.jaadee.net/active/course/course_30.jpg" alt />
            <p>8月：8月30日与字节跳动集团合作共建多宝之城LiVE直播基地。</p>
            <img src="https://res.jaadee.net/active/course/course_31.jpg" alt />
            <p>12月：国家级玉雕大师张炳光、王朝阳等10余位玉雕大师与翡翠王朝强强联手，联合举办大师定制节，为翠友量身打造一场私人定制的翡翠珍藏品盛宴。</p>
            <img src="https://res.jaadee.net/active/course/course_32.jpg" alt />
          </div>
        </div>
      </div>
      <div class="card">
        <span class="icon">
          <img src="@/assets/svg/about/us_timeline_icon.svg" alt />
        </span>
        <div class="card-content">
          <h2 class="title">2020年</h2>
          <div class="box">
            <p>
              2月：全国抗击疫情关键时刻，翡翠王朝迅速行动，发动全员募捐，筹集善款260725元资金，捐赠到新冠病毒感染肺炎疫情防控工作中使用，共克时艰！
            </p>
            <img src="https://res.jaadee.net/active/course/course_33.jpg" alt />
            <p>
              3月：云南省委书记陈豪率队到LiVE直播基地指导工作，他要求我们充分发挥瑞丽独特的人文优势和资源优势，加强平台管理，大力引进设计、加工企业，打造翡翠产品全产业链，努力把瑞丽建设成为我国珠宝玉石交易中心。
            </p>
            <img src="https://res.jaadee.net/active/course/course_34.jpg" alt />
            <p>
              3月：在德宏州副州长李朝伟的陪同下，玉溪市市长到多宝之城LiVE直播基地调研，为瑞丽市珠宝产业数字经济新发展惊叹不已：新模式，新发展，新希望！
            </p>
            <img src="https://res.jaadee.net/active/course/course_35.jpg" alt />
            <p>
              4月：云南省省长阮成发亲临视察，对字节跳动集团、瑞丽政府管理部门所探索出的基地管理模式、翡翠王朝公司对直播基地的具体管理，都给与充分肯定，并指示要将瑞丽建设成为我国珠宝玉石交易中心。
            </p>
            <img src="https://res.jaadee.net/active/course/course_36.jpg" alt />
            <p>
              5月：在翡翠王朝相关负责人陪同下德宏州委副书记、州长卫岗一行到北京字节跳动科技公司总部调研。
            </p>
            <img src="https://res.jaadee.net/active/course/course_37.jpg" alt />
            <p>
              6月：瑞丽珠宝玉石首饰行业协会为翡翠王朝颁发奖项并授牌第六届理事会会场单位翡翠王朝第五届理事会“社会公益奖”及“行业先锋奖”。
            </p>
            <img src="https://res.jaadee.net/active/course/course_38.jpg" alt />
            <p>
              6月：国家税务总局瑞丽市税务局在多宝之城举办珠宝玉石互联网直播行业税法宣传活动，并正式在多宝之城LiVE直播基地设置瑞丽市区（除姐告外）翡翠成品税款代征点。
            </p>
            <img src="https://res.jaadee.net/active/course/course_39.jpg" alt />
            <p>
              7月：与字节跳动集团合作共建广东平洲LiVE直播基地。
            </p>
            <img src="https://res.jaadee.net/active/course/course_40.jpg" alt />
            <p>
              10月：情系胞波，携手抗疫。由瑞丽市妇联、瑞丽市妇女儿童发展中心和云南翡翠王朝共同捐赠的防疫物资，从瑞丽口岸姐告出入境通道抵达缅甸木姐地区。
            </p>
            <img src="https://res.jaadee.net/active/course/course_41.jpg" alt />
            <p>
              10月：截至2020年10月底，多宝之城LiVE直播基地直播企业达860余家，实现日销售最高峰值为70000单，从直播基地发往全国的珠宝玉石超过870万件，销售总额超过51亿元。
            </p>
            <img src="https://res.jaadee.net/active/course/course_42.jpg" alt />
            <p>
              11月：瑞丽市个体私营经济协会勐卯分会揭牌仪式在瑞丽市多宝之城LiVE直播基地举行。翡翠王朝创始人杨牧仁当选为个体私营经济协会勐卯分会长。
            </p>
            <img src="https://res.jaadee.net/active/course/course_43.jpg" alt />

          </div>
        </div>
      </div>
      <div class="card">
        <span class="icon">
          <img src="@/assets/svg/about/us_timeline_icon.svg" alt />
        </span>
        <div class="card-content">
          <h2 class="title">2021年</h2>
          <div class="box">
            <p>
              1月，中缅胞波街在多宝之城开市，抖音、快手、拼多多等数百家直播间同时开播。
            </p>
            <img src="https://res.jaadee.net/active/course/2021/pic1-2.jpg" alt />
            <p>1月，LiVE直播基地2020年度商家大会在多宝之城举办。 </p>
            <img src="https://res.jaadee.net/active/course/2021/pic1-1.jpg" alt />
            <p>
              2月，为方便进出多宝之城人员进行核酸检测，多宝之城核酸检测点正式启用。
            </p>
            <img src="https://res.jaadee.net/active/course/2021/pic2-1.jpg" alt />
            <p>3月，翡翠王朝当选广东省珠宝玉石首饰行业协会常务副会长单位。</p>
            <img src="https://res.jaadee.net/active/course/2021/pic3-1.jpg" alt />
            <p>9月，“璀璨青春 筑梦未来”翡翠王朝爱心助学鹿城镇军屯完小公益活动举行。</p>
            <img src="https://res.jaadee.net/active/course/2021/pic9-1.jpg" alt />
            <p>9月，抖音珠宝电商直播基地昆明运营中心试运行。 </p>
            <img src="https://res.jaadee.net/active/course/2021/pic9-2.jpg" alt />
            <p>
              10月，翡翠王朝体系送福文化珠宝IP“手镯一姐”刘思懿，以平洲抖音电商直播基地“手镯形象大使”身份亮相平洲玉器珠宝小镇翡翠全品类直播集市嘉年华主会场。多家媒体以《“手镯一姐”为平洲玉器推流》为题进行报道。
            </p>
            <img src="https://res.jaadee.net/active/course/2021/pic10-1.jpg" alt />
          </div>
        </div>
      </div>
      <div class="card">
        <span class="icon">
          <img src="@/assets/svg/about/us_timeline_icon.svg" alt />
        </span>
        <div class="card-content">
          <h2 class="title">2022年</h2>
          <div class="box">
            <p>5月：翡翠王朝联合益众打造平洲首个新场景直播大卖场。益众直播大卖场开启平洲珠宝玉石产业线上、线下融合发展新篇章，益客户、益货主、益商家、一起赢！</p>
            <img src="https://res.jaadee.net/active/course/course_20220501.jpg" alt />
          </div>
        </div>
      </div>
    </div>
    <div class="future">
      <span class="icon">
        <img src="@/assets/svg/about/us_history_future_icon.svg" alt />
      </span>
      <div class="content">
        <h2>未来</h2>
        <p>我们的精彩才刚刚开始……</p>
      </div>
    </div>
    <about-footer v-show="kaiguan?false:true"></about-footer>
  </div>
</template>

<script>
import AboutFooter from '../AboutFooter'
export default {
  name: 'history',
  components: {
    AboutFooter
  },
  data() {
    return {

    }
  },
  props: {
    kaiguan: {
      type: Boolean,
    }
  },
  created() {
  },
  computed: {
  },
  mounted() {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped >
.history {
  text-align: left;
  padding: 0 0.21rem;
  background-color: rgba(255, 255, 255, 1);
  p {
    font-size: 0.1867rem;
    color: rgba(29, 29, 29, 1);
    line-height: 0.2667rem;
    letter-spacing: 2px;
  }
  .card {
    display: flex;
    padding-top: 0.36rem;
    .icon {
      margin-right: 0.13rem;
      height: 0.99rem;
      width: 0.13rem;
      margin-top: 0.02rem;
      flex-shrink: 0;
    }
    .card-content {
      h2 {
        font-size: 0.2133rem;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
        line-height: 0.2133rem;
        padding-bottom: 0.13rem;
      }
      .box {
        border-radius: 0.04rem;
        border: 1px solid rgba(155, 194, 181, 1);
        padding: 0.2rem;
        img {
          padding: 0.06rem 0;
        }
      }
    }
  }
}
.future {
  background-color: rgba(255, 255, 255, 1);
  padding: 0.4rem 0.21rem;
  display: flex;
  align-items: center;
  text-align: left;
  .icon {
    width: 0.48rem;
    height: 0.48rem;
    margin-right: 0.13rem;
  }
  .content {
    h2 {
      font-size: 0.2rem;
      color: rgba(29, 29, 29, 1);
      line-height: 0.2rem;
      padding-bottom: 0.11rem;
    }
    p {
      font-size: 0.1733rem;
      font-weight: 400;
      color: rgba(114, 114, 114, 1);
      line-height: 0.1733rem;
    }
  }
}
</style>
